import RaceMixins from '../../../../../components/_mixins/races'
import config from '../../../../../lib/config'
const {min} = Math
import {alert, getQS} from '../../../../../lib/utils'
const qs = getQS() || {}
const noHold = !!qs.nohold

export default {
  name: 'timeslot',
  mixins: [RaceMixins],
  props: {
    time: { default: null },
    disabled: { default: false },
  },
  data() {
    return {
      isProcessing: false,
      maxSelectedSlots: config.MAX_SELECTED_SLOTS || 5,
      item: {}
    }
  },
  created() {
    this.item = this.retrievedTimeslot(this.time)
  },
  computed: {
    disableSelection() {
      // return this.disabled ||
      //   !this.selected && this.totalRacesNotSlotted <= 0 ||
      //   !this.selected && !this.usePackages && this.numberOfSelectedAllTimeslots >= this.maxSelectedSlots
      return this.disabled || false
    },
    selected: {
      get() {
        return this.item.selected
      },
      set(value) {
        const item = this.item
        this.setRetrieved(item, 'selected', value)
      }
    }
  },
  methods: {
    setSelected({time}, key, value) {
      this.setTimeslotData({time, key, value})
    },
    setRetrieved({time}, key, value) {
      this.setRetrievedTimeslotData({time, key, value})
    },
    setRacers(item, value) {
      this.setSelected(item, 'racers', value)
    },
    setHold(item, value) {
      this.setSelected(item, 'hold', value)
    },
    selectTemporary(item) {
      this.selectTimeslot(item)
      this.updateRacersRacesMatrixOnSelection()
    },
    deselectTemporary() {
      this.setRacers(0)
      this.updateRacersRacesMatrixOnSelection()
    },
    getNumRacesToSlot(){
      const usePackages = this.usePackages
      const racingSeparately = this.isRacingSeparately
      const racers = this.totalPlayers || 0
      const remainingRacesToSlot = this.totalRacesNotSlotted || 0
      const maxSelectableRaces = usePackages ? this.maxSelectableRaces: 0
      const currentMaxPerSlot = usePackages ? this.currentMaxSelectableRacesPerSlot : remainingRacesToSlot
      const racesToSlot = min(racers, remainingRacesToSlot, currentMaxPerSlot) || 0
      const finalRacesToSlot = racingSeparately ? 0 : racesToSlot
      return finalRacesToSlot
    },
    async selection() {
      if (this.item.processing) {
        alert('This selected slot is being processed.')
        return false
      }

      if (!this.selected && this.totalRacesNotSlotted <= 0 && this.isAnyProcessing()) {
        alert('You have reached maximum selection of slots and one or more slots are being processed. Wait until all the processing are done.')
        return false
      }

      const time = this.item.time
      const selected = this.selected = !this.selected
      const now = (new Date()).valueOf()
      const itemToSet = {time, selected: selected ? now : false}

      if (this.selected && !this.isRacingSeparately && !this.totalRacesNotSlotted) {
        this.unholdFirstSelectedSlot()
      }

      const racers = itemToSet.racers = this.getNumRacesToSlot()

      if (!selected) {
        // deselect
        this.deselectTemporary()
        await this.unholdSlot(this.item)

      }  else {
        this.selectTemporary(itemToSet)

        if (!noHold && racers) {
          const holds = await this.holdSlot(this.item, racers)
          itemToSet.holds = holds

          // unable to hold
          if (!holds) {
            this.selected = itemToSet.selected = false
          }
        }
      }
      this.updateTimeslotSelection(itemToSet)
      this.updateRacersRacesMatrixOnSelection()
    }
  }

}
